import React from 'react';
import { useGetStarted } from './GetStartedContext';

interface ProgressProps {
  isProgressNumber?: boolean;
}

const Progress: React.FC<ProgressProps> = ({ isProgressNumber = false }) => {
  const { completedPercentage, themeManager, formdata } = useGetStarted();

  return (
    <div className="q_gt_progress">
      <div
        className="q_progress_percentage"
        style={themeManager.getProgressBarStyles().text}
      >
        {!isProgressNumber ? Math.floor(completedPercentage) + "% Completed" : completedPercentage + "/" + formdata.length}
      </div>
      <div
        className="q_gt_progress_bar"
        style={{
          background: themeManager.getProgressBarStyles().bar.background,
        }}
      >
        <div
          className="q_progress_bar_completed"
          style={{
            width: !isProgressNumber ? `${completedPercentage}%` : `${(completedPercentage * 100) / formdata.length}%`,
            background: themeManager.getProgressBarStyles().bar.fill,
          }}
        />
      </div>
    </div>
  );
};

export default Progress;